var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeftIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18.075,
  height: 17.447,
  viewBox: "0 0 18.075 17.447"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#2c2c39",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.475 8.724H.6",
  "data-name": "Path 221"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.475.849.6 8.724l7.875 7.875",
  "data-name": "Path 222"
}))));
export default SvgArrowLeftIcon;